import { Formik } from 'formik';
import { Col, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { memberStatusObj } from './utils';
import { formSelectDefault } from '../../Components/constants/styles';
import Select from 'react-select';
import { APIClient } from '../../helpers/ApiHeleps';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { useSelector } from 'react-redux';

const AddMemberStatusModal = ({ onCloseClick, show, initialObj, refreshDashboard }) => {
    const api = new APIClient();
    const userCredential = useSelector((state) => state.CommonStore.loginToken);
    const [loading, setLoading] = useState(false);

    const handleSave = async (data) => {
        if (initialObj?.memberStatus?.value === data?.memberStatus?.value) {
            toast.warning('Member status already exist.');
            return;
        }
        let payLoad = {
            uniqueLink: data?.uniquelink,
            memberStatus: data?.memberStatus?.value
        };

        try {
            setLoading(true);
            let resp = await api.update(`${data?.uniquelink}/status`, userCredential, payLoad);
            if (resp?.data?.isSuccess) {
                refreshDashboard();
                setLoading(false);
                onCloseClick();
            } else if (!resp?.data?.isSuccess) {
                toast.error('API failed try again.');
                setLoading(false);
            }
        } catch (error) {
            toast.error('Something went wrong please try again.');
            setLoading(false);
        }
    };
    return (
        <Modal isOpen={show} toggle={onCloseClick} size="md" centered={true}>
            <ModalHeader className="bg-soft-primary">Edit Member Status</ModalHeader>
            <ModalBody className="px-5 py-3">
                <Formik
                    initialValues={initialObj}
                    onSubmit={(values) => {
                        handleSave(values);
                    }}
                >
                    {({ setFieldValue, values, errors, handleSubmit, touched, handleBlur }) => (
                        <>
                            <Row>
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex mb-4">
                                    <Label className="col-form-label w-40">
                                        Member Status
                                        {/* <span className="text-danger">*</span> */}
                                    </Label>
                                    <Select
                                        value={values?.memberStatus}
                                        onChange={(e) => {
                                            setFieldValue('memberStatus', e);
                                        }}
                                        options={[
                                            { label: memberStatusObj[1], value: 1 },
                                            { label: memberStatusObj[2], value: 2 },
                                            { label: memberStatusObj[3], value: 3 },
                                            { label: memberStatusObj[4], value: 4 },
                                            { label: memberStatusObj[5], value: 5 },
                                            { label: memberStatusObj[6], value: 6 },
                                            { label: memberStatusObj[7], value: 7 },
                                            { label: memberStatusObj[8], value: 8 },
                                            { label: memberStatusObj[9], value: 9 },
                                            { label: memberStatusObj[10], value: 10 }
                                        ]}
                                        placeholder={'Select'}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        styles={formSelectDefault}
                                        id={'memberStatusObj'}
                                        getOptionLabel={(e) => e.label}
                                        getOptionValue={(e) => e.label}
                                        className="w-60"
                                    />
                                </Col>
                            </Row>
                            <div className="mt-4 float-right  d-flex">
                                <button
                                    type="button"
                                    className="btn btn-md btn-primary "
                                    data-bs-dismiss="modal"
                                    disabled={!values?.memberStatus || loading}
                                    onClick={handleSubmit}
                                    id="goalSave"
                                >
                                    {loading ? 'Loading' : 'Save'}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-md ms-3 btn-outline-primary"
                                    id="goalCancel"
                                    onClick={onCloseClick}
                                >
                                    Cancel
                                </button>
                            </div>
                        </>
                    )}
                </Formik>
            </ModalBody>
        </Modal>
    );
};

export default AddMemberStatusModal;
